/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
export const transformImages = (list) => {
  const res = [];
  for (const el of list) {
    res[el.node.name] = el;
  }
  return res;
};
